export default "__VITE_ASSET__8fc9be17__"